{
  "cart_purchase": {
    "defaultMessage": "Purchase",
    "description": "Label for Purchase word"
  },
  "cart_cart_details": {
    "defaultMessage": "Cart Details",
    "description": "Header for Cart Popup"
  },
  "cart_discount_label": {
    "defaultMessage": "Buy more images to get a discount",
    "description": "A discount description"
  },
  "cart_digital_image": {
    "defaultMessage": "Digital Image(s)",
    "description": "Label for digital image(s) description"
  },
  "cart_no_selected_image": {
    "defaultMessage": "Please select image(s) to purchase before checkout",
    "description": "Label for no selected image message"
  },
  "cart_checkout": {
    "defaultMessage": "Checkout",
    "description": "Label for checkout word"
  },
  "cart_sorry_charge_problem": {
    "defaultMessage": "Sorry, we experienced a problem that prevented this charge from going through. Please try again and contact us if the problem persists.",
    "description": "Message for Stripe Charge"
  },
  "cart_image_free_of_charge": {
    "defaultMessage": "This {imageDesc} will be provided free of charge.",
    "description": "Message for notice of image free of charge"
  },
  "cart_credit_debit_card": {
    "defaultMessage": "Credit or Debit card",
    "description": "Header for checkout form"
  },
  "cart_thank_you_purchase": {
    "defaultMessage": "Thank you for your purchase!",
    "description": "Message for purchase success"
  },
  "cart_link_to_gallery": {
    "defaultMessage": "A link to your gallery has been sent to {email}",
    "description": "Message for description of gallery link"
  },
  "cart_view_photos": {
    "defaultMessage": "View Photos",
    "description": "Label for View Photos"
  },
  "cart_price_guide": {
    "defaultMessage": "Price Guide",
    "description": "Header for Price Guide panel"
  },
  "cart_price_guide_notes": {
    "defaultMessage": "See Price Guide for pricing",
    "description": "Notes for Price Guide"
  },
  "cart_cart_total": {
    "defaultMessage": "Cart Total",
    "description": "Label for Cart Total"
  },
  "cart_standard_price": {
    "defaultMessage": "Standard price is {amount} each",
    "description": "Line describing the standard price"
  },
  "cart_buy_all_at_price": {
    "defaultMessage": "Buy All Price is {amount}",
    "description": "Line describing user can buy all at price of"
  },
  "cart_add_image_no_cost": {
    "defaultMessage": "You may add more images at no cost",
    "description": "Line describing user can add image with no cost"
  },
  "cart_purchasing": {
    "defaultMessage": "Purchasing",
    "description": "Label for Checkout form button"
  },
  "cart_purchased": {
    "defaultMessage": "Purchased",
    "description": "Tab name for purchased gallery"
  },
  "cart_unpurchased": {
    "defaultMessage": "Unpurchased",
    "description": "Tab name for unpurchased gallery"
  },
  "cart_digitals": {
    "defaultMessage": "{quantity, plural, one {# Digital Image} other {# Digital Images}}",
    "description": "Line describing the number of digital images purchased"
  },
  "cart_prints": {
    "defaultMessage": "{quantity, plural, one {# Print} other {# Prints}}",
    "description": "Line describing the number of prints purchased"
  },
  "cart_digitals_and_prints": {
    "defaultMessage": "{digitals, plural, one {# Digital Image} other {# Digital Images}} & {quantity, plural, one {# Print} other {# Prints}}",
    "description": "Line describing the number of digital images and prints purchased"
  },
  "cart_unlock_all": {
    "defaultMessage": "All Digital Images",
    "description": "Line describing that all digital images have been purchased"
  },
  "cart_unlock_all_prints": {
    "defaultMessage": "All Digital Images & Prints",
    "description": "Line describing that all digital images and prints have been purchased"
  },
  "cart_total": {
    "defaultMessage": "Total",
    "description": "Label for purchase total"
  },
  "cart_on_date": {
    "defaultMessage": "on {date}",
    "description": "Line describing the date that a purchase occurred"
  },
  "cart_buy_all_discount_label": {
    "defaultMessage": "{price} for all",
    "description": "Label for discounted price to purchase all images"
  },
  "cart_buy_all_discount_description": {
    "defaultMessage": "Buy all images for {price}",
    "description": "Description for discounted price to purchase all images"
  },
  "cart_volume_discount_label": {
    "defaultMessage": "{percent} off {quantity} or more",
    "description": "Label for percent-off discount on a minimum quantity of images"
  },
  "cart_volume_discount_description": {
    "defaultMessage": "Buy {quantity, plural, one {# image} other {# images}} and get {percent} off",
    "description": "Description for percent-off discount on a minimum quantity of images"
  },
  "cart_packages_discount_label": {
    "defaultMessage": "{quantity} for {price}",
    "description": "Label for discounted price to purchase a specific quantity of images"
  },
  "cart_packages_discount_description": {
    "defaultMessage": "Get {quantity, plural, one {# image} other {# images}} for {price}",
    "description": "Description for discounted price to purchase a specific quantity of images"
  },
  "cart_packages_discount_label_range": {
    "defaultMessage": "{minimum}-{maximum} for {price}",
    "description": "Label for discounted price to purchase a quantity-range of images"
  },
  "cart_packages_discount_description_range": {
    "defaultMessage": "Get {minimum}-{maximum} images for {price}",
    "description": "Description for discounted price to purchase a quantity-range of images"
  },
  "cart_packages_discount_description_all": {
    "defaultMessage": "Get all images for {price}",
    "description": "Description for discounted price to purchase all images"
  },
  "cart_apply_coupon": {
    "defaultMessage": "Apply",
    "description": "Label for the button to apply a coupon code"
  },
  "cart_coupon_code": {
    "defaultMessage": "Coupon Code",
    "description": "Placeholder text for coupon code input"
  },
  "cart_coupon_code_instructions": {
    "defaultMessage": "Please enter your coupon code to apply it to your order.{br}Click continue to proceed to checkout",
    "description": "Instructions for coupon code slide"
  },
  "cart_no_photos_available": {
    "defaultMessage": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started",
    "description": "Message informing the user they have no photos"
  },
  "cart_purchase_unavailable": {
    "defaultMessage": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view",
    "description": "Message informing the user that mobile purchase has been disabled"
  }
}
